import { render, staticRenderFns } from "./TenantUserPicklist.vue?vue&type=template&id=94a97466"
import script from "./TenantUserPicklist.vue?vue&type=script&lang=js"
export * from "./TenantUserPicklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports